/* qeslint-disable */

export const Theme = {
    // photoshop colors
    a: "#343434",
    b: "#535353",
    c: "#b8b8b8",
    d: "#d6d6d6"
};
